<template>
  <div class="main-wrapper terms-page innerpagebg">
    <layouts-header v-if="!authStore.user"></layouts-header>
    <user-header v-if="authStore.user"></user-header>
    <breadcrumb :title="title" :text="text" :text1="text1" />
    <div class="content">
      <div class="container">
        <h3>Chính sách của chúng tôi</h3>
        <div class="condition-details">
          <ul>
            <li  v-for="(policy) in policy" :key="policy.id">
              <div v-if="policy.type == 'privacy'" >
                <h4>{{ policy.title }}</h4>                  
                  <div style="color: black;" v-html="policy.description"></div>       
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<script>
import axios from 'axios';
import { useAuthStore } from "@/stores/auth";
import { getPolicy } from '@/api/strapi/policy';

export default {
  data() {
    const authStore = useAuthStore();
    return {
      authStore,
      title: "Chính sách",
      text: "Trang chủ",
      text1: "Chính sách",
      policy:[],
    };
  },
  methods:{
    async fetchPrivacy(){
      try{
        const response = await getPolicy();
        this.policy = response.data;
      }catch(error){
        console.log('Lỗi lấy dữ liệu: ',error);
      }
    }
  },
  async created(){
    await this.fetchPrivacy();
  }
};
</script>
